export const props = { viewBox: "0 0 26 24" };
export const innerHTML = '<path xmlns="http://www.w3.org/2000/svg" d="M13 24L5.18001e-06 -8.4248e-07L26 1.43051e-06L13 24Z" fill="#B60909"/>';
